const WINDOW_ENV = (window as any).env;
export const debounceTime = 300;

export const apiUrl = WINDOW_ENV?.API_URL;
